import { toast, Slide } from 'react-toastify';

const baseOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
  transition: Slide,
};

const showToastIfNew = (type, title) => {
  const message = title ?? "";
  const toastId = `${type}:${message}`;

  // Swallow duplicate while the same toast is still visible
  if (toast.isActive(toastId)) {
    return;
  }

  toast[type](message, {
    ...baseOptions,
    toastId,
  });
};

export const showErrorToast = (title) => {
  showToastIfNew("error", title);
};

export const showInfoToast = (title) => {
  showToastIfNew("info", title);
};

export const showSuccessToast = (title) => {
  showToastIfNew("success", title);
};

export default showErrorToast;
